// src/pages/BrowseTechnicians.js
import React, { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { Link } from "react-router-dom";
import { db } from "../utilities/firebaseConfig";

const BrowseTechnicians = () => {
  const [technicians, setTechnicians] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const techRef = ref(db, "technicians");
    onValue(techRef, (snapshot) => {
      if (snapshot.exists()) {
        const techArray = Object.entries(snapshot.val()).map(([id, tech]) => ({
          id,
          ...tech,
        }));
        setTechnicians(techArray);
      }
    });
  }, []);

  const filteredTechs = technicians.filter((tech) =>
    filter ? tech.service.toLowerCase().includes(filter.toLowerCase()) : true
  );

  return (
    <div>
      <h2>Browse Technicians</h2>
      <input
        type="text"
        placeholder="Filter by service..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      {filteredTechs.length > 0 ? (
        filteredTechs.map((tech) => (
          <div key={tech.id} style={{ border: "1px solid #ccc", padding: "10px", margin: "10px" }}>
            <h4>{tech.name}</h4>
            <p><strong>Service:</strong> {tech.service}</p>
            {tech.pricing && tech.pricing[tech.service] && (
              <p><strong>Price:</strong> ${tech.pricing[tech.service].price}</p>
            )}
            <Link to={`/technician-profile/${tech.id}`}>View Profile</Link>
          </div>
        ))
      ) : (
        <p>No technicians found.</p>
      )}
      <Link to="/dashboard">Back to Dashboard</Link>
    </div>
  );
};

export default BrowseTechnicians;
